import { prepareSort } from 'helpers/participantsTableSort'
import api from '../..'
import { UserData } from './types'

const participantsList = (page: number, searchText: string, sort: any) => {
  const q = {
    g: [
      {
        m: 'or',
        lms_active_false: true,
        lms_active_null: true,
      },
      {
        m: 'and',
        full_name_or_position_or_identifier_or_area_name_cont: searchText,
      },
    ],
    s: prepareSort(sort),
  }

  return api
    .post<{ data: UserData[] }>(`administration/users/search`, {
      page,
      per_page: 10,
      q,
    })
    .then(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total']),
        perPage: parseInt(headers['per-page']),
      }
    })
}

export default participantsList
